function toggleTab() {
  let id = 'faq-' + this.getAttribute('data-id');
  let activeHeading = document.getElementsByClassName('collapsible-content__heading active'); 
  let setTab = document.getElementById(id);
  let activeTab = document.getElementsByClassName('faq-section active');

  if(window.innerWidth < 641) {
      let faqTabs = document.getElementById('faq-tabs');

      if(faqTabs.classList.contains('active')) {
          faqTabs.classList.remove('active');
      } else {
          faqTabs.classList.add('active');
      }
  }

  for(var i = 0; i < activeHeading.length; i++) {
      activeHeading[i].classList.remove('active');
  }
  this.classList.add('active');

  for(var i = 0; i < activeTab.length; i++) {
      activeTab[i].classList.remove('active');
  }
  setTab.classList.add('active');
  
}

document.addEventListener('DOMContentLoaded', function() {    
  let faqHeadings = document.getElementsByClassName('collapsible-content__heading');
  let faqTabs = document.querySelector('#faq-tabs');

  Array.prototype.forEach.call(faqHeadings, function(el, index) {
      faqTabs.appendChild(el)
      el.addEventListener('click', toggleTab);

      if(!index) {
          el.classList.add('active')
          document.getElementById('faq-' + el.getAttribute('data-id')).classList.add('active')
      }
  });
});